import { render, staticRenderFns } from "./WarehouseLocationComponent.vue?vue&type=template&id=06a297f0"
import script from "./WarehouseLocationComponent.vue?vue&type=script&lang=js"
export * from "./WarehouseLocationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports